{
	"$schema": "./schema.json",
	"name": "Grayscale",
	"colorSchemes": {
		"dark": {
			"pcbLayers": {
				"colorsByType": [
					{
						"layerType": "F",
						"colors": ["rgba(96,96,96,0.8)"]
					},
					{
						"layerType": "B",
						"colors": ["rgba(158,158,158,0.8)"]
					},
					{
						"layerType": "Inner",
						"colors": [
							"rgba(225,225,225,0.8)",
							"rgba(189,189,189,0.8)",
							"rgba(224,224,224,0.8)",
							"rgba(150,150,150,0.8)",
							"rgba(149,149,149,0.8)",
							"rgba(198,198,198,0.8)",
							"rgba(121,121,121,0.8)",
							"rgba(125,125,125,0.8)",
							"rgba(83,83,83,0.8)"
						]
					},
					{
						"layerType": "Edge",
						"colors": ["rgba(199,199,199,1.0)"]
					},
					{
						"layerType": "Other",
						"colors": ["#B7B7B7", "#565656", "rgb(117,117,117)", "#CCCCCC", "#212121", "#454545", "#A2A2A2"]
					},
					{
						"layerType": "SilkS",
						"front": ["#9E9E9E"],
						"back": ["#AEAEAE"],
						"colors": ["#B3B3B3"]
					},
					{
						"layerType": "Mask",
						"front": ["#ABABAB"],
						"back": ["#7A7A7A"],
						"colors": ["#999999"]
					},
					{
						"layerType": "Paste",
						"back": ["#C5C5C5"],
						"front": ["#9B9B9B"],
						"colors": ["#858585", "#ACACAC"]
					}
				]
			},
			"schLayers": {
				"colorsByType": [
					{
						"layerType": "Background",
						"colors": ["rgba(251,251,251,0.8)"]
					},
					{
						"layerType": "Bus",
						"colors": ["rgba(10,10,10,0.9)"]
					},
					{
						"layerType": "BusJunction",
						"colors": ["rgba(10,10,10,0.9)"]
					},
					{
						"layerType": "Label",
						"colors": ["rgba(107,107,107,0.9)"]
					},
					{
						"layerType": "Wire",
						"colors": ["rgba(107,107,107,0.9)"]
					},
					{
						"layerType": "Junction",
						"colors": ["rgba(107,107,107,0.9)"]
					},
					{
						"layerType": "Pin",
						"colors": ["rgba(28,28,28,0.9)"]
					},
					{
						"layerType": "PinNumber",
						"colors": ["rgba(28,28,28,0.9)"]
					},
					{
						"layerType": "Symbol",
						"colors": ["rgba(28,28,28,0.9)"]
					},
					{
						"layerType": "PinName",
						"colors": ["rgba(79,79,79,0.9)"]
					},
					{
						"layerType": "NameLabel",
						"colors": ["rgba(79,79,79,0.9)"]
					},
					{
						"layerType": "ValueLabel",
						"colors": ["rgba(79,79,79,0.9)"]
					},
					{
						"layerType": "Image",
						"colors": ["#FFFFFF"]
					}
				]
			},
			"tools": {
				"default": {
					"default": "#5B5B5B",
					"overlay": "#7A7A7A",
					"selectedElements": "#C6C6C6",
					"userSelection": "#727272",
					"background": "#252525"
				},
				"iruler": {
					"default": "#FFFFFF",
					"textShadow": "#000000"
				},
				"grid": {
					"default": "rgba(0,0,0,0.31)",
					"major": "rgba(0,0,0,0.47)"
				}
			}
		},
		"light": {
			"pcbLayers": {
				"colorsByType": [
					{
						"layerType": "F",
						"colors": ["rgba(96,96,96,0.8)"]
					},
					{
						"layerType": "B",
						"colors": ["rgba(158,158,158,0.8)"]
					},
					{
						"layerType": "Inner",
						"colors": [
							"rgba(225,225,225,0.8)",
							"rgba(189,189,189,0.8)",
							"rgba(224,224,224,0.8)",
							"rgba(150,150,150,0.8)",
							"rgba(149,149,149,0.8)",
							"rgba(198,198,198,0.8)",
							"rgba(121,121,121,0.8)",
							"rgba(125,125,125,0.8)",
							"rgba(83,83,83,0.8)"
						]
					},
					{
						"layerType": "Edge",
						"colors": ["#4F4F4F"]
					},
					{
						"layerType": "Other",
						"colors": ["#B7B7B7", "#565656", "rgb(117,117,117)", "#CCCCCC", "#212121", "#454545", "#A2A2A2"]
					},
					{
						"layerType": "SilkS",
						"front": ["#9E9E9E"],
						"back": ["#AEAEAE"],
						"colors": ["#B3B3B3"]
					},
					{
						"layerType": "Mask",
						"front": ["#ABABAB"],
						"back": ["#7A7A7A"],
						"colors": ["#999999"]
					},
					{
						"layerType": "Paste",
						"back": ["#C5C5C5"],
						"front": ["#9B9B9B"],
						"colors": ["#858585", "#ACACAC"]
					}
				]
			},
			"schLayers": {
				"colorsByType": [
					{
						"layerType": "Background",
						"colors": ["rgba(251,251,251,0.8)"]
					},
					{
						"layerType": "Bus",
						"colors": ["rgba(10,10,10,0.9)"]
					},
					{
						"layerType": "BusJunction",
						"colors": ["rgba(10,10,10,0.9)"]
					},
					{
						"layerType": "Label",
						"colors": ["rgba(107,107,107,0.9)"]
					},
					{
						"layerType": "Wire",
						"colors": ["rgba(107,107,107,0.9)"]
					},
					{
						"layerType": "Junction",
						"colors": ["rgba(107,107,107,0.9)"]
					},
					{
						"layerType": "Pin",
						"colors": ["rgba(28,28,28,0.9)"]
					},
					{
						"layerType": "PinNumber",
						"colors": ["rgba(28,28,28,0.9)"]
					},
					{
						"layerType": "Symbol",
						"colors": ["rgba(28,28,28,0.9)"]
					},
					{
						"layerType": "PinName",
						"colors": ["rgba(79,79,79,0.9)"]
					},
					{
						"layerType": "NameLabel",
						"colors": ["rgba(79,79,79,0.9)"]
					},
					{
						"layerType": "ValueLabel",
						"colors": ["rgba(79,79,79,0.9)"]
					},
					{
						"layerType": "Image",
						"colors": ["#FFFFFF"]
					}
				]
			},
			"tools": {
				"default": {
					"default": "#B7B7B7",
					"overlay": "#7A7A7A",
					"selectedElements": "#727272",
					"userSelection": "#727272",
					"background": "#252525"
				},
				"iruler": {
					"default": "#000000",
					"textShadow": "#FFFFFF"
				},
				"grid": {
					"default": "rgba(0,0,0,0.13)",
					"major": "rgba(0,0,0,0.22)"
				}
			}
		}
	}
}
